var map = {
	"./AP-CHAP03-PHOTO.png": 303,
	"./AP-CHAP04-CITATIONGERD.png": 304,
	"./CHAP03-PHOTO.png": 305,
	"./CHAP04-CITATION2.png": 306
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;



//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img ^\.\/.*$
// module id = 91
// module chunks = 0